import { Button, Spinner, Table } from 'react-bootstrap'

export const DelayedPackagesTable = ({ delayedPackages, changeDelayStatus, isLoading }) => {
  return (
    <Table className='tableForPackagePage' style={{ width: '70%' }}>
      <thead>
        <tr style={{ backgroundColor: '#fcde00', color: 'white' }}>
          <th>XLT</th>
          <th>Full Name</th>
          <th>Unit</th>
          <th>Location</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        {delayedPackages &&
          delayedPackages.map(delayedPackage => {
            return (
              <tr key={delayedPackage.id}>
                <td>{delayedPackage.trackingNumberToIsrael}</td>
                <td>
                  {delayedPackage.costumer_firstName} {delayedPackage.costumer_LastName}
                </td>
                <td>{delayedPackage.unit}</td>
                <td>{delayedPackage.warehouseLocation}</td>
                <td>
                  {!isLoading ? (
                    <Button onClick={() => changeDelayStatus(delayedPackage)}>
                      {delayedPackage.delayStatus === '30' ? 'Subtract' : 'Donate'}
                    </Button>
                  ) : (
                    <Spinner animation='border' variant='primary' />
                  )}
                </td>
              </tr>
            )
          })}
      </tbody>
    </Table>
  )
}
